module.exports = __webpack_public_path__ + "static/media/KT.ba0e5160.png";